export { CombinedProcedureCodesValueSet } from "@/constants/billing";

/**
 * Max concurrent ValueSet expands when rebuilding the combined procedure ValueSet. Caps burst
 * traffic to Medplum (terminology expands plus nested CodeSystem reads per expand) to reduce
 * 429 / throttling risk while still beating fully sequential wall-clock time.
 */
export const COMBINED_VALUE_SET_EXPAND_CONCURRENCY = 4;

/** Code system of the Current Procedural Terminology codes in the hosted CPT ValueSet. */
export const CPT_CODE_SYSTEM = "http://www.ama-assn.org/go/cpt";

/** Code system of HCPCS, which holds both Level II codes and modifiers. */
export const HCPCS_CODE_SYSTEM = "https://www.cms.gov/Medicare/Coding/HCPCSReleaseCodeSets";
